import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-buylicense',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './buylicense.html',
  styleUrls: ['./buylicense.scss']
})
export class Buylicense {
  constructor(private router: Router) {}
  currentYear = new Date().getFullYear();

  // Simula acción de compra
  buyNow(): void {
    alert('Redirigiendo a la página de compra...');
    // Aquí puedes navegar a una ruta o abrir un enlace real
    this.router.navigate(['/purchase']);
  }

  // Cierra la modal (por ejemplo, regresa al home)
  closeModal(): void {
    this.router.navigate(['/home']);
  }
}
